import { Route, Routes } from 'react-router-dom'
import Layout from '../UI/Layout/Layout'
import Live from './Survey/Live/Live'
import Preview from './Survey/Preview/Preview'
import Naw from './NAW/NAW'
import NawImmoraum from './NawImmoraum/NawImmoraum'
import immoraumLogo from '../../assets/image/naw/immoraum/logo.png'

const Public = () => {
  const CustomLayout = ({ children, logo = null, headerBGColor = null, smallHeader = true }) => (
    <Layout
      authLevelRequired={false}
      hideNavigation
      disableDynamicHeightHeader
      smallHeader={smallHeader}
      className="bg-white"
      logo={logo}
      headerBGColor={headerBGColor}
    >
      {children}
    </Layout>
  )
  return (
    <Routes>
      {/* survey routes */}
      <Route
        path={'survey/:surveyUUID'}
        element={
          <CustomLayout>
            <Live />
          </CustomLayout>
        }
      />
      <Route
        path={'survey-preview/:surveyUUID'}
        element={
          <CustomLayout>
            <Preview />
          </CustomLayout>
        }
      />
      {/* naw routes */}
      <Route
        path={'naw/immoraum'}
        element={
          <CustomLayout logo={immoraumLogo} headerBGColor={'bg-white'} smallHeader={false}>
            <NawImmoraum />
          </CustomLayout>
        }
      />
      <Route
        path={'naw/:nawSurveyUUID'}
        element={
          <CustomLayout>
            <Naw />
          </CustomLayout>
        }
      />
      <Route
        path={'naw'}
        element={
          <CustomLayout>
            <Naw />
          </CustomLayout>
        }
      />
    </Routes>
  )
}

export default Public
